import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=8060de9e&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8060de9e')) {
      api.createRecord('8060de9e', component.options)
    } else {
      api.reload('8060de9e', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=8060de9e&", function () {
      api.rerender('8060de9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4hF4RzGF0ycu7/JS/videoIframe.vue"
export default component.exports